import React from "react";
import homeLogo from "../images/myimage.png";
import { Text, Button, Box, Flex, Grid, Center } from "@chakra-ui/react";

const About = () => {
  const onButtonClick = () => {
      window.open("https://drive.google.com/file/d/1EYpEpzdVOVw07ZeoE-uojOc6LOqaBX6w/view?usp=sharing","_blank")
      const fileID = "1EYpEpzdVOVw07ZeoE-uojOc6LOqaBX6w"; // Replace with your file's ID
      const fileName = "Kamalakanta-Mahapatra.pdf"; // Replace with the desired file name
      
      // Create a direct download link
      const downloadLink = `https://drive.google.com/uc?export=download&id=${fileID}`;
      
      // Create an invisible link element
      const link = document.createElement("a");
      link.href = downloadLink;
      link.target = "_blank"; // Open the link in a new tab/window
      link.download = fileName;
    
      // Trigger the click event on the link to initiate the download
      link.click();
  };

  return (
    <div id="about" className="about section">
      <Grid
        id="about-inner"
        templateColumns={["1fr", "repeat(2, 1fr)"]}
        ml={[0, "10%"]}
        gap={4}
      >
        <Center>
          <Text id="user-detail-intro" fontSize="2xl" w={"90%"}>
            <h1 style={{ fontSize: "40px", color: "#cd5ff8", margin: "auto" }}>About</h1>
            Hello, I'm <span style={{ color: "#cd5ff8" }}>Kamalakanta Mahapatra</span>, a determined and versatile Full Stack MERN developer.
            <br /> With a passion for web development and a solid foundation in{" "}
            <span style={{ color: "#cd5ff8" }}>MongoDB, Express.js, React.js, Node.js, and JavaScript</span> and <span style={{ color: "#cd5ff8" }}>Java</span>, I'm committed to creating impactful and user-centric applications.
            <br /> I thrive on continuous learning, embracing challenges, and collaborating with like-minded professionals to build innovative solutions.
            <br /> Let's connect and explore the possibilities together.
          </Text>
        </Center>
        <Center className="home-imgee">
          <img src={"https://i.imgur.com/VbaAFGt.png"} style={{width:"55%"}} alt="home pic" className="home-img" />
        </Center>
      </Grid>
      <Center m={"5%"} ml={0}>
        <div className="heading-name">
          <Text>
            Download <strong className="main-name">Resume:</strong>
          </Text>
          <Button
            backgroundColor="#a891b7"
            _hover={{ bg: "#a891b7", color: "black" }}
            color="white"
            variant="solid"
            onClick={onButtonClick}
            size={["sm", "md"]}
            id="resume-button-2"
          >
            RESUME
          </Button>
        </div>
      </Center>
    </div>
  );
};

export default About;
